import { render, staticRenderFns } from "./dashboard-balance.vue?vue&type=template&id=23308062&scoped=true&"
import script from "./dashboard-balance.vue?vue&type=script&lang=js&"
export * from "./dashboard-balance.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-balance.vue?vue&type=style&index=0&id=23308062&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23308062",
  null
  
)

export default component.exports